export const ENABLE_EXPANDED_CHAT_WIDTH = true;
export const ENABLE_VOICE_INPUT = false;
